/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EmbedConfig } from '../model';
/**
 * EmbedConfigApi - axios parameter creator
 * @export
 */
export const EmbedConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the configuration
         * @param {string} embedConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicConfigRetrieve: async (embedConfigId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'embedConfigId' is not null or undefined
            assertParamExists('publicConfigRetrieve', 'embedConfigId', embedConfigId)
            const localVarPath = `/v2/public/config/{embed_config_id}`
                .replace(`{${"embed_config_id"}}`, encodeURIComponent(String(embedConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Style for the embed
         * @param {string} embedConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicConfigStyleCssRetrieve: async (embedConfigId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'embedConfigId' is not null or undefined
            assertParamExists('publicConfigStyleCssRetrieve', 'embedConfigId', embedConfigId)
            const localVarPath = `/v2/public/config/{embed_config_id}/style.css`
                .replace(`{${"embed_config_id"}}`, encodeURIComponent(String(embedConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmbedConfigApi - functional programming interface
 * @export
 */
export const EmbedConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmbedConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the configuration
         * @param {string} embedConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicConfigRetrieve(embedConfigId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicConfigRetrieve(embedConfigId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Style for the embed
         * @param {string} embedConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicConfigStyleCssRetrieve(embedConfigId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicConfigStyleCssRetrieve(embedConfigId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmbedConfigApi - factory interface
 * @export
 */
export const EmbedConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmbedConfigApiFp(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the configuration
         * @param {string} embedConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicConfigRetrieve(embedConfigId: string, options?: any): AxiosPromise<EmbedConfig> {
            return localVarFp.publicConfigRetrieve(embedConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Style for the embed
         * @param {string} embedConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicConfigStyleCssRetrieve(embedConfigId: string, options?: any): AxiosPromise<string> {
            return localVarFp.publicConfigStyleCssRetrieve(embedConfigId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for publicConfigRetrieve operation in EmbedConfigApi.
 * @export
 * @interface EmbedConfigApiPublicConfigRetrieveRequest
 */
export interface EmbedConfigApiPublicConfigRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof EmbedConfigApiPublicConfigRetrieve
     */
    readonly embedConfigId: string
}

/**
 * Request parameters for publicConfigStyleCssRetrieve operation in EmbedConfigApi.
 * @export
 * @interface EmbedConfigApiPublicConfigStyleCssRetrieveRequest
 */
export interface EmbedConfigApiPublicConfigStyleCssRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof EmbedConfigApiPublicConfigStyleCssRetrieve
     */
    readonly embedConfigId: string
}

/**
 * EmbedConfigApi - object-oriented interface
 * @export
 * @class EmbedConfigApi
 * @extends {BaseAPI}
 */
export class EmbedConfigApi extends BaseAPI {
    /**
     * Allow external IDs to be used for generic API views.
     * @summary Fetch the configuration
     * @param {EmbedConfigApiPublicConfigRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbedConfigApi
     */
    public publicConfigRetrieve(requestParameters: EmbedConfigApiPublicConfigRetrieveRequest, options?: any) {
        return EmbedConfigApiFp(this.configuration).publicConfigRetrieve(requestParameters.embedConfigId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Style for the embed
     * @param {EmbedConfigApiPublicConfigStyleCssRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbedConfigApi
     */
    public publicConfigStyleCssRetrieve(requestParameters: EmbedConfigApiPublicConfigStyleCssRetrieveRequest, options?: any) {
        return EmbedConfigApiFp(this.configuration).publicConfigStyleCssRetrieve(requestParameters.embedConfigId, options).then((request) => request(this.axios, this.basePath));
    }
}
